"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusSystemFixedT = exports.StatusSystemFixed = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * When an status is fixed and it's removed, it's ID is sent
 */
class StatusSystemFixed {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsStatusSystemFixed(bb, obj) {
        return (obj || new StatusSystemFixed()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsStatusSystemFixed(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new StatusSystemFixed()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    fixedStatusId() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    static startStatusSystemFixed(builder) {
        builder.startObject(1);
    }
    static addFixedStatusId(builder, fixedStatusId) {
        builder.addFieldInt32(0, fixedStatusId, 0);
    }
    static endStatusSystemFixed(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createStatusSystemFixed(builder, fixedStatusId) {
        StatusSystemFixed.startStatusSystemFixed(builder);
        StatusSystemFixed.addFixedStatusId(builder, fixedStatusId);
        return StatusSystemFixed.endStatusSystemFixed(builder);
    }
    unpack() {
        return new StatusSystemFixedT(this.fixedStatusId());
    }
    unpackTo(_o) {
        _o.fixedStatusId = this.fixedStatusId();
    }
}
exports.StatusSystemFixed = StatusSystemFixed;
class StatusSystemFixedT {
    constructor(fixedStatusId = 0) {
        this.fixedStatusId = fixedStatusId;
    }
    pack(builder) {
        return StatusSystemFixed.createStatusSystemFixed(builder, this.fixedStatusId);
    }
}
exports.StatusSystemFixedT = StatusSystemFixedT;
